import React, { useState } from 'react';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import {
    ServiceLgImg1,
    ServiceLgImg2,
    ServiceLgImg3,
    ServiceLgImg4,
    ServiceLgImg5,
} from '../../Constant/Index';
import { useParams, Link } from 'react-router-dom';
const ServiceDetials = () => {
    let Para1 = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum";
    let Para2 = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,"
    let Para3 = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum";
    let ItemsList = [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod",
        "tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,",
        "quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
        "Duis aute irure dolor in reprehenderit",
        "in voluptate velit esse cillum dolore eu",
        "fugiat nulla pariatur. Excepteur sint occaecat cupidatat",
        "non proident, sunt in culpa qui officia",
        "deserunt mollit anim id est laborum"
    ];
    const ServicesData = [
        {
            id: 1,
            ServiceName: "Air Freight",
            FirstPara: Para1,
            SecondPara: Para2,
            ServiceImg: ServiceLgImg1,
            ServiceLastPara: Para3,
            Listheading: "Experienced, Safe and Dependable",
            ListItems: ItemsList
        },
        {
            id: 2,
            ServiceName: "Ocean Freight ",
            FirstPara: Para1,
            SecondPara: Para2,
            ServiceImg: ServiceLgImg2,
            ServiceLastPara: Para3,
            Listheading: "Reliable and Quick Service",
            ListItems: ItemsList
        },
        {
            id: 3,
            ServiceName: "Custom Brokerage",
            FirstPara: Para1,
            SecondPara: Para2,
            ServiceImg: ServiceLgImg3,
            ServiceLastPara: Para3,
            Listheading: "Reliable and Quick Service",
            ListItems: ItemsList
        },
        {
            id: 4,
            ServiceName: "Warehousing",
            FirstPara: Para1,
            SecondPara: Para2,
            ServiceImg: ServiceLgImg4,
            ServiceLastPara: Para3,
            Listheading: "Secured warehousing and distribution Service",
            ListItems: ItemsList
        }, {
            id: 5,
            ServiceName: "Special Cargo",
            FirstPara: Para1,
            SecondPara: Para2,
            ServiceImg: ServiceLgImg5,
            ServiceLastPara: Para3,
            Listheading: "Experienced, Safe and Dependable",
            ListItems: ItemsList
        }

    ];
    const { id } = useParams();
    const CurrentService = ServicesData.find(obj => obj.id === parseInt(id));
    return (
        <>
            <Header />
            {/* Service Detials Section Start Here */}
            {CurrentService ? (
                <>
                    <section className="service-details">
                        <div className="container">
                            <div className="details-body">
                                <div className="top-heaidng text-center mt-3 mt-lg-5 pt-3 mb-3 mt-lg-5">
                                    <h1 className="lg-heading captalize-text">{CurrentService.ServiceName}</h1>
                                </div>
                                <div className="text-start">
                                    <p className="text">
                                        {CurrentService.FirstPara}
                                    </p>
                                    <p className="text">
                                        {CurrentService.SecondPara}
                                    </p>
                                    <figure className="main-image mt-4 mb-5">
                                        <img src={CurrentService.ServiceImg} alt="" className="the-img w-100" />
                                    </figure>
                                    <p className="text">
                                        {CurrentService.ServiceLastPara}
                                    </p>
                                </div>
                                <div className="points-serives">
                                    <h3 className="md-heading">{CurrentService.Listheading}</h3>
                                    <ul className="points-list">
                                        {
                                            CurrentService.ListItems.map((CurrentItem, index) => (
                                                <li className="list-items text" key={index}>{CurrentItem}</li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : (
                <>
                    <div className="error text-center my-5">
                        <h1 className='text-center mb-4'>Service Note Found</h1>
                        <Link to="/services" className="btn">Back To Services</Link>
                    </div>
                </>
            )}

            {/* Service Detials Section End Here */}
            {/* Footer Included Here */}
            <Footer />
            {/* Footer Included Here */}
        </>
    )
}
export default ServiceDetials;